import {
  InstantSearchContext,
  InstantSearchContextInterface,
} from "../components/instant-search/context";

import { useContext } from "react";

export const useInstantSearch = (): InstantSearchContextInterface =>
  useContext(InstantSearchContext);
